/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import Chart from 'react-apexcharts';

import {
  Card as CardUI,
  CardHeader,
  CardContent,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
  Button,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Autorenew } from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

const styles = {
  title: {
    color: '#7b7b7b',
  },
  rootContent: {
    padding: '0px',
    '&:last-child': {
      paddingBottom: '0px',
    },
  },
  gutters: {
    paddingLeft: '0px',
    paddingRight: '16px',
  },
  secondaryNegative: {
    color: '#b73c3c !important',
  },
  secondaryPositive: {
    color: '#2d7d2d !important',
  },
  alterar: {
    color: '#4caf50',
    margin: '2rem',
  },
};

class Card extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          width: '100%',
        },
        tooltip: { enabled: false },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: 0,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          categories: [''],
        },
        legend: {
          position: 'bottom',
          offsetX: 0,
          offsetY: 0,
          horizontalAlign: 'left',
        },
        fill: {
          opacity: 1,
        },
      },
    };
  }

  render() {
    const { station, refreshProduct, classes } = this.props;
    const { options } = this.state;

    const estoque = parseFloat(
      (station.saldo * 100) / station.capacidade
    ).toFixed(2);
    const vazio = parseFloat(
      (station.espacoVazio * 100) / station.capacidade
    ).toFixed(2);

    return (
      <Grid item md={4} sm={12}>
        <CardUI>
          <CardHeader
            title={station.titulo}
            classes={{ title: classes.title }}
          />
          <CardContent classes={{ root: classes.rootContent }}>
            <Box display="flex">
              <Box style={{ maxWidth: '145px', minWidth: '145px' }}>
                <Chart
                  options={{
                    ...options,
                    colors: [station.cor || '#6E8BA1', '#ADADAD'],
                  }}
                  series={[
                    {
                      name: t('s.controleestoque.estoque'),
                      data: [estoque],
                    },
                    {
                      name: t('s.controleestoque.espacovazio'),
                      data: [vazio],
                    },
                  ]}
                  type="bar"
                  height={350}
                />
              </Box>
              <Box>
                <List dense>
                  <ListItem divider classes={{ gutters: classes.gutters }}>
                    <ListItemText
                      primary={t('c.menu.stock.capacidade')}
                      secondary={station.capacidade.toLocaleString('pt-BR', {
                        maximumFractionDigits: 1,
                      })}
                    />
                  </ListItem>
                  <ListItem divider classes={{ gutters: classes.gutters }}>
                    <ListItemText
                      primary={t('s.controleestoque.espacovazio')}
                      secondary={station.espacoVazio.toLocaleString('pt-BR', {
                        maximumFractionDigits: 1,
                      })}
                    />
                  </ListItem>
                  <ListItem divider classes={{ gutters: classes.gutters }}>
                    <ListItemText
                      classes={{
                        secondary:
                          station.saldo <= 0
                            ? classes.secondaryNegative
                            : classes.secondaryPositive,
                      }}
                      secondaryTypographyProps={{
                        variant: 'h5',
                      }}
                      primary={t('s.operacao.estoqueproduto.saldo')}
                      secondary={station.saldo.toLocaleString('pt-BR', {
                        maximumFractionDigits: 2,
                      })}
                    />
                  </ListItem>
                  <ListItem divider classes={{ gutters: classes.gutters }}>
                    <ListItemText
                      primary={t('s.operacao.estoqueproduto.dataalteracao')}
                      secondary={moment(station.atualizacao).format(
                        'DD/MM/YYYY HH:mm:ss'
                      )}
                    />
                  </ListItem>
                  {canURL().update && (
                    <ListItem divider classes={{ gutters: classes.gutters }}>
                      <Button
                        onClick={() => refreshProduct()}
                        className={classes.alterar}
                        variant="contained"
                        size="small"
                      >
                        <Autorenew />
                        {t('s.operacao.estoqueproduto.alterarestoque')}
                      </Button>
                    </ListItem>
                  )}
                </List>
              </Box>
            </Box>
          </CardContent>
        </CardUI>
      </Grid>
    );
  }
}

Card.propTypes = {
  refreshProduct: PropTypes.func.isRequired,
  station: PropTypes.objectOf(PropTypes.any).isRequired,
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles)(Card);
